import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/jobTrackingEnabled`;

export const ROUTE: RouteDefinition = `${baseRoute}/jobTrackingEnabled`;

export const URL = (): RouteDefinition => `${baseRoute}/jobTrackingEnabled`;
